import { StyleSheet, View } from 'react-native';
import { EsSignupContainer } from '../../components/ScreenContainer/EsSignupContainer';
import { SignUpdata } from '../../components/EsSignupForm/EsSignupForm';
import { useDispatchPromise } from '../../utils/AppUtils';
import {
    IFieldAvailabilityData,
    TUserField,
    createUserProfile,
    getPhoneVerificationCode,
    startUserDetailsAvailabilitySearch,
    updateUserProfile,
} from '../../redux/user/actions';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../types/global/routes.types';
import { useState } from 'react';
import { TOnChangePayload } from '../../components/EsSignupForm/Interests';
import { SentryCapture } from '../../analytics/Sentry';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
});

const Signup = () => {
    const dispatch = useDispatchPromise();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [otpLoading, setOtpLoading] = useState(false);
    const [resendInProgress, setResendInProgress] = useState(false);

    const onSubmitSignUpOTP = (data: SignUpdata, code?: string[], next?: VoidFunction) => {
        const payload = {
            ...data,
            code: code?.join(''),
        };
        setOtpLoading(true);
        dispatch(createUserProfile(payload))
            .then(() => {
                setOtpLoading(false);
                next && next();
                setLoading(false);
            })
            .catch(e => {
                setOtpLoading(false);
                setLoading(false);
            });
    };

    const checkUserDataAvailability = (data: SignUpdata, next: () => void, field: TUserField) => {
        const payload: IFieldAvailabilityData =
            field === 'userName'
                ? { field: 'userName', request: { userName: data.userName } }
                : { field: 'phoneNumber', request: { phoneNumber: data.phoneNumber, email: data.email } };

        setLoading(true);
        dispatch(startUserDetailsAvailabilitySearch(payload))
            .then(() => {
                setLoading(false);
                if (field !== 'userName') next();
            })
            .catch(e => {
                setLoading(false);
            });
    };

    const getSignUpOTP = (data: SignUpdata, next: () => void, resend?: boolean): void | Promise<unknown> => {
        const payload = { phoneNumber: data.phoneNumber, email: data.email, resendToken: resend };
        if (resend) {
            setResendInProgress(true);
            return dispatch(getPhoneVerificationCode(payload))
                .then(() => {
                    setResendInProgress(false);
                    setLoading(false);
                })
                .catch(e => {
                    setResendInProgress(false);
                    setLoading(false);
                });
        } else {
            setLoading(!loading);
            dispatch(getPhoneVerificationCode(payload))
                .then(() => {
                    setLoading(!loading);
                    next();
                })
                .catch(e => {
                    setLoading(!loading);
                });
        }
    };

    const handleUpdateUserDetails = (payload: TOnChangePayload) => {
        dispatch(updateUserProfile(payload))
            .then(val => {
                navigate(ROUTES.FEED);
            })
            .catch(e => {
                SentryCapture(e);
                navigate(ROUTES.FEED);
            });
    };

    const handleLoadingState = () => setLoading(false);

    const userNameAvailable = (userName: string) => {
        if (userName.replaceAll(' ', '') !== '') {
            const data = { userName: userName } as SignUpdata;
            checkUserDataAvailability(data, handleLoadingState, 'userName');
        }
    };
    return (
        <View style={styles.container}>
            <EsSignupContainer
                getSignUpOTP={getSignUpOTP}
                userNameAvailable={userNameAvailable}
                onSubmitSignUpOTP={onSubmitSignUpOTP}
                checkUserDataAvailability={checkUserDataAvailability}
                otpLoading={otpLoading}
                loading={loading}
                resendInProgress={resendInProgress}
                updateUserDetails={handleUpdateUserDetails}
            />
        </View>
    );
};

export { Signup };
